export enum DataPresentation {
  Colon,
  RoundBrackets,
}
